export var dummy = "dummy";
//# sourceMappingURL=dummy.js.map